import { ExpandLess, ExpandMore } from "@mui/icons-material";
import {
  Box,
  Button,
  Chip,
  IconButton,
  Paper,
  Popover,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
} from "@mui/material";
import moment from "moment";
import InvoiceItem from "pages/reports/InvoiceItem";
import React, { useEffect } from "react";

const SalesItem = ({ order, openRows , setOpenRefund }) => {
  const [open, setOpen] = React.useState(openRows);
  useEffect(() => {
    setOpen(openRows);
  }, [openRows]);
  const openInNewTab = (uuid) => {
    var host = window.location.protocol
      .concat("//")
      .concat(window.location.host);
    const url = `${host}/invoice/${uuid}`;
    const newWindow = window.open(url, "_blank", "noopener,noreferrer");
    if (newWindow) newWindow.opener = null;
  };
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [origin, setOrigin] = React.useState("");

  const handleClick = (event, from) => {
    setAnchorEl(event.currentTarget);
    setOrigin(from);
  };

  const openHSN = Boolean(anchorEl) && origin === "hsn";
  const handleClose = () => {
    setAnchorEl(null);
    setOrigin("");
  };

  

  return (
    <>
      <TableRow
        sx={{
          "&:last-child td, &:last-child th": { border: 0 },
          backgroundColor: open ? "lightgrey" : "white",
        }}
      >
        <TableCell
          align="left"
          component="th"
          scope="row"
          sx={{
            ...(order.vend_status === "failed" && { color: "#faad14 " }),
            ...(order.vend_status === "waiting" && { color: "blue" }),
          }}
        >
          {order.order_no}
        </TableCell>
        <TableCell align="center" component="th" scope="row">
          {order.machine_name}
        </TableCell>
        <TableCell align="center" component="th" scope="row">
          {order.customer_name ?? "-"}
        </TableCell>
        <TableCell align="center" component="th" scope="row">
          {moment(order.created_date).format("MMMM Do YYYY, h:mm:ss a")}
        </TableCell>

        <TableCell align="center" component="th" scope="row">
          ₹{order.payable_amount}
        </TableCell>
        <TableCell align="center" component="th" scope="row">
          ₹{order.total_discount.toFixed(2)}
        </TableCell>
        <TableCell align="center" component="th" scope="row">
          {order.qty}
        </TableCell>
        <TableCell align="center" component="th" scope="row">
          {order.payment_name ?? "Free vend"}
        </TableCell>
        <TableCell align="center" component="th" scope="row">
          <IconButton onClick={() => setOpen((state) => !state)}>
            {open ? <ExpandLess /> : <ExpandMore />}
          </IconButton>
        </TableCell>
      </TableRow>
      {openHSN && (
        <Popover
          open={openHSN}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          sx={{ width: 1500 }}
        >
          <Box padding={2}>
            <Stack direction="row" spacing={2}>
              <Typography flex={5}>
                {" "}
                <Box component="span" fontWeight="bold">
                  HSN No
                </Box>
              </Typography>
              <Typography flex={8} sx={{ textAlign: "center" }}>
                {" "}
                <Box component="span" fontWeight="bold">
                  Taxable amount
                </Box>
              </Typography>
              <Typography flex={4} sx={{ textAlign: "center" }}>
                <Box component="span" fontWeight="bold">
                  CGST
                </Box>
              </Typography>
              <Typography flex={4} sx={{ textAlign: "center" }}>
                <Box component="span" fontWeight="bold">
                  SGST
                </Box>
              </Typography>
              <Typography flex={4} sx={{ textAlign: "end" }}>
                <Box component="span" fontWeight="bold">
                  CESS
                </Box>
              </Typography>
            </Stack>
            {order.hsn_calc.map((hsn, index) => (
              <Stack direction="row" spacing={2} key={index}>
                <Typography flex={5} sx={{}}>
                  {hsn.hsn_code}
                </Typography>
                <Typography flex={8} sx={{ textAlign: "center" }}>
                  {hsn.taxable_amount.toFixed(2)}
                </Typography>
                <Typography flex={4} sx={{ textAlign: "center" }}>
                  {hsn.cgst > 0 ? `${hsn.cgst_total} \n (${hsn.cgst}%)` : 0.0}
                </Typography>
                <Typography flex={4} sx={{ textAlign: "center" }}>
                  {hsn.sgst > 0 ? `${hsn.sgst_total} \n (${hsn.sgst}% )` : 0.0}
                </Typography>
                <Typography flex={4} sx={{ textAlign: "end" }}>
                  {hsn.cess > 0 ? `${hsn.cess_total} \n (${hsn.cess}%)` : 0.0}
                </Typography>
              </Stack>
            ))}
          </Box>
        </Popover>
      )}
      {open && (
        <>
          <TableRow>
            <TableCell colSpan="9">
              <Stack direction="column" sx={{ paddingX: 3 }}>
                <Paper
                  sx={{
                    paddingX: 3,
                    paddingY: 2,
                  }}
                >
                  <Stack direction="row" justifyContent="space-between">
                    <Typography>
                      Payment txn ID : {order.payment_transaction_id ?? "Nil"}{" "}
                    </Typography>
                    <Typography>
                      Payment reference ID :{" "}
                      {order.payment_reference_id ?? "Nil"}{" "}
                    </Typography>
                    {order.refund_log && (
                      <>
                        <Typography>
                          Refund txn ID :{" "}
                          {order.refund_log.transaction_id ?? "Nil"}
                        </Typography>
                        <Typography>
                          Refund reference ID :{" "}
                          {order.refund_log.reference_id ?? "Nil"}
                        </Typography>

                        <Typography>
                          Refund amount : {order.refund_log.amount}Rs
                        </Typography>
                        <Typography>
                          Refund status :{" "}
                          {order.refund_log.success ? (
                            <span style={{ color: "green" }}>Success </span>
                          ) : (
                            <span style={{ color: "red" }}>Failed</span>
                          )}
                        </Typography>
                      </>
                    )}
                  </Stack>
                  <Stack direction="row">
                    <Typography>Global offers applied:</Typography>
                    {order.global_offers.map((offer) => (
                      <Box key={offer.id}>
                        <Tooltip
                          title={`${offer.offer_name} (${offer.offer_code}) min price ${offer.min_purchase_price}`}
                          sx={{ ml: 1 }}
                          disableInteractive
                        >
                          <Chip
                            label={`${offer.offer_name} ${offer.offer_percentage}%`}
                            variant="outlined"
                            size="small"
                            clickable
                          />
                        </Tooltip>
                      </Box>
                    ))}
                  </Stack>
                  <Stack
                    direction="row"
                    justifyContent="space-between"
                    spacing={1}
                    mt={2}
                  >
                    <Box sx={{ display: "flex", gap: 1 }}>
                      <Button
                        variant="outlined"
                        size="small"
                        onClick={() => openInNewTab(order.uuid)}
                      >
                        View invoice
                      </Button>
                      <Button
                        variant="outlined"
                        size="small"
                        onClick={(e) => handleClick(e, "hsn")}
                      >
                        View HSN breakout
                      </Button>
                    </Box>
                    {order.payment_name === "UPI-bharatQR" && (
                      <Button
                        variant="outlined"
                        size="small"
                        onClick={(e) => {
                          setOpenRefund(order);
                        }}
                        color="error"
                        disabled={
                          order.refund_log &&
                          order.refund_log.success === true &&
                          order.refund_log.amount === order.payable_amount
                        }
                      >
                        Manual refund
                      </Button>
                    )}
                  </Stack>
                </Paper>
                <Table sx={{ margin: 0 }}>
                  <TableHead>
                    <TableRow
                      sx={{
                        "& th": {
                          color: "text.secondary",
                        },
                      }}
                    >
                      <TableCell>S.No</TableCell>
                      <TableCell align="center">Product name</TableCell>
                      <TableCell align="center">Unit price</TableCell>
                      <TableCell align="center">Quantity</TableCell>
                      <TableCell align="center">Amount paid</TableCell>
                      <TableCell align="center">Discount</TableCell>
                      <TableCell align="center">Vend status</TableCell>
                      <TableCell align="center">Vend logs</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {order.invoices.map((invoice, index) => (
                      <InvoiceItem
                        key={invoice.id}
                        invoice={invoice}
                        index={index}
                        global_offers={order.global_offers}
                      />
                    ))}
                  </TableBody>
                </Table>
              </Stack>
            </TableCell>
          </TableRow>
        </>
      )}
    </>
  );
};

export default SalesItem;
